export default {
  en: {
    base: {
      cancel: 'Cancel',
      customer: 'Customer',
      perUnit: 'per unit',
      perSms: 'per SMS',
      subscription: 'Subscription',
    },
    globalEvents: {
      enterpriseMigrationRequest: {
        title: 'Business migration request',
        description: (data) => `from: ${data.values.data.sourceEnterprise.name} \
(${data.values.data.sourceEnterprise.id}), to: \
${data.values.data.destinationEnterprise.name} \
(${data.values.data.destinationEnterprise.id})`,
      },
      enterpriseMigrationSuccessful: {
        title: 'Business migration successful',
        description: (data) => `from: ${data.values.data.sourceEnterprise.name} \
(${data.values.data.sourceEnterprise.id}), to: \
${data.values.data.destinationEnterprise.name} \
(${data.values.data.destinationEnterprise.id})`,
      },
      enterpriseMigrationFailed: {
        title: 'Business migration failed',
        description: (data) => `from: ${data.values.data.sourceEnterprise.name} \
(${data.values.data.sourceEnterprise.id}), to: \
${data.values.data.destinationEnterprise.name} \
(${data.values.data.destinationEnterprise.id})`,
      },
      userMfaRemoved: {
        title: 'User SMS 2FA removed',
        description: (data) => `from: ${data.values.data.targetUser.id} \
(business ${data.values.data.targetUser.enterpriseId})`,
      },
      documentDeleted: {
        title: 'Document deleted',
        description: (data) => `ID: ${data.values.data.document.id} \
(business ${data.values.data.document.enterpriseId})`,
      },
      documentDeletionFailure: {
        title: 'Document deletion failure',
        description: (data) => `ID: ${data.values.data.document.id} \
(business ${data.values.data.document.enterpriseId})`,
      },
      recipientReset: {
        title: 'Recipient reset',
        description: (data) => `ID: ${data.values.data?.recipient?.id} \
(document ${data.values.data?.document?.id})`,
      },
    },
    paging: {
      more: 'More',
      totalCount: 'Total entries: {count}',
    },
    buttons: {
      main: {
        createBusiness: 'Create business',
      },
      application: {
        approve: 'Approve application',
        disable: 'Disable application',
        reject: 'Reject application',
        enable: 'Reenable application',
        search: 'Find applications',
      },
      price: {
        create: 'Create price',
        more: 'More prices',
      },
      product: {
        change: 'Change product',
        showInactive: 'Show inactive prices',
        showLegacy: 'Show legacy prices (unconfigured)',
        editable: 'Editable',
      },
      enterprise: {
        turnIntoFreeForever: 'Set as free forever',
        requestFreeForever: 'Turn user into Free forever',
        create: 'Create business',
        synchroniseSubscription: 'Synchronise subscription with Stripe',
        transferUserCheck: 'Search business',
        transferUser: 'Transfer user to business',
      },
    },
    billing: {
      allocatedText: 'plus {count} per period',
      usageTypes: {
        metered: 'Pay as you go',
        licensed: 'Licensed',
      },
      schedule: 'one time each',
      intervalCount: '| | {count}',
      intervals: {
        month: 'month | months',
        year: 'year | years',
      },
    },
    fields: {
      application: {
        id: 'Application ID',
        active: 'Active',
        description: 'Description',
        name: 'Name',
        scopes: 'Capabilities',
        requestedScopes: 'Requested capabilities',
        createdAt: 'Created at',
        updatedAt: 'Last updated at',
        approvedAt: 'Approved at',
        disabledAt: 'Disabled at',
        enterprise: 'Business (application administrator)',
        scope: {
          business: 'All operations on a business',
        },
        searchTerm: 'Name, business ID',
        status: 'Status',
        rejectedAt: 'Rejected at',
        rejectionReason: 'Rejection reason',
      },
      base: {
        notSet: 'Not set',
        na: 'N/A',
      },
      billing: {
        quota: 'Document quota',
        quotaRenewal: 'Quota renewals',
        schedule: 'Billing schedule',
        smsUnitAmount: 'SMS overage price',
        overageUnitAmount: 'Document overage price',
        subscriptionType: 'Subscription type',
        unitAmount: 'Price',
        notSet: 'Not set by billing price',
        quotaRenewals: {
          month: 'monthly',
          year: 'yearly',
          undefined: 'Not set by billing price',
        },
        kind: 'Plan',
        product: {
          name: 'Name',
          description: 'Description',
        },
      },
      customer: {
        email: 'Client billing e-mail address',
        name: 'Client name',
      },
      newEnterprise: {
        email: 'User e-mail address',
        name: 'Customer complete name',
        businessName: 'Business name',
      },
      product: {
        id: 'ID',
        name: 'Name',
        active: 'Active',
        provider: 'Provider',
      },
      user: {
        name: 'Name',
        email: 'E-mail',
        enterpriseId: 'Business ID',
      },
    },
    messages: {
      application: {
        pendingApproval: 'Application pending approval',
        approvedAt: 'Application approved at {approvedAt}',
        disabledAt: 'Disabled at {disabledAt}',
        applicationApproved: 'Application approved.',
        applicationDisabled: 'Application disabled.',
        applicationEnabled: 'Application enabled.',
        confirmRejection: 'Confirm application rejection?',
        inputRejectionReason: 'Please type a rejection reason. If blank, we will not notify the'
        + ' application administrator.',
        applicationRejected: 'Application rejected.',
      },
      billing: {
        subscription: {
          confirmAssignment: 'If there are any fields not set by the billing price, they will '
          + 'have to be manually configured. If the billing price information contains, for '
          + 'example, information on document quota, this will reconfigure the business quota.',
          typeASubscription: 'Please type a subscription ID (beginning with sub_)',
          assigned: 'Subscription assigned.',
        },
      },
      enterprise: {
        turnIntoFreeForever: 'After this action, the business account will reset to the Free Forever plan '
        + 'and automatically its allocated documents and quota become 5, seats become 1. '
        + 'All API keys and SAML integrations will be turned off. All managed users (extra users) will be deactivated. '
        + 'The current subscription will be cancelled, but the Stripe customer ID remains. The owner’s account '
        + 'will be updated to match a free user (period will reset, subscription will be removed, '
        + 'document overage price and SMS overage price become zero). '
        + 'Caution - '
        + 'For metered (PAYG) plans, outstanding usage is billed automatically at cancellation. For standard plans, '
        + 'it will not be billed automatically and must be billed manually before this action.',
        checkUserTransfer: 'Check if user can be transferred to another business',
        checkUserTransferInfo: 'This user needs to be the sole user in this business. It will '
        + 'transfer the user as an Enterprise User of the other business. Their documents and '
        + 'templates will be copied to personal folders.',
        confirmTurnIntoFreeForever: 'Confirm setting business as Free forever?',
        create: 'This form creates a new business with the Trial plan. It does not notify the '
        + 'client that the business was created.',
        changeLevel: {
          admin: 'This will make the user an administrator. It will give this user the '
          + 'same rights as the account owner.',
          user: 'This will make the user a normal enterprise user.',
        },
        transferringDocuments: 'Transferring documents between users',
      },
      customer: {
        searchByEmail: 'Search billing customer by e-mail',
      },
      product: {
        confirmSwitchToEditable: 'Confirm switching product to editable?',
        confirmSwitchToNotEditable: 'Confirm switching product to not editable?',
        switchToEditableDescription: 'You are changing this product to editable. This will allow '
        + 'you to create prices for this product.',
        switchToNotEditableDescription: 'You are changing this product to not editable. This will '
        + 'prevent you from creating prices. Check this option if this product exclusively '
        + 'includes prices or plans you will not edit such as Business, Business pro.',
      },
      price: {
        emptyStateCreate: 'Create price',
        emptyStateCreateDescription: 'Create the first price for this product.',
      },
    },
    widgets: {
      transferDocuments: {
        documentsToTransfer: 'No documents to transfer. | Will transfer one document, preserving '
        + 'folder locations | Will transfer {count} documents, preserving folder locations '
        + 'and brands. Note that the transfer is irreversible.',
        from: 'From:',
        to: 'To:',
        cancel: 'Cancel transfer',
        commit: 'Transfer documents',
      },
    },
    titles: {
      application: {
        index: 'Applications',
        show: 'Application',
        find: 'Find an application',
      },
      business: {
        index: 'Businesses',
        show: 'Business',
        subscription: 'Subscription',
        createBusiness: 'Create business',
        newBusiness: 'New business',
      },
      customer: {
        manage: 'Manage customer',
      },
      product: {
        index: 'Billing products',
        show: 'Billing product',
      },
    },
    tooltips: {
      application: {
        approvedAt: 'The date and time we approved this application to be online.',
        disabledAt: 'The date and time we disabled this application.',
        rejectedAt: 'The date and time we rejected this application after the developer request.',
        rejectionReason: 'The reason we provided the developer when rejecting their application.',
      },
      enterprise: {
        paygIncorrect: 'Subscription is set to metered, but enterprise PAYG is not set.',
        periodStartDiffers: 'Subscription period start differs from Stripe. Please resynchronise.',
        periodEndDiffers: 'Subscription period end differs from Stripe. Please resynchronise.',
        documentSurplus: 'Document surplus after deducting quota. Means that if having a subscription, after the subscription is ideally charged, the business will still have this number of documents as a surplus.',
        documentDeficit: 'Document deficit after deducting quota. Means that even after charging the subscription, the business will have this number of outstanding documents.',
        documentsSentInPeriod: 'Number of documents sent in the PleaseSign subscription period. If Stripe and PleaseSign subscription periods differ, this number will be incorrect.',
        allocatedInfo: 'Allocated documents should be set to zero if the plan is metered.',
        subscriptionInterval: 'This field is used by the scheduled cron job to fetch standard accounts on yearly Stripe plans that require monthly automatic overage billing. It is automatically updated whenever a Stripe subscription is created or updated. If updating manually, please ensure it matches the Stripe subscription interval.',
        annualCommitmentMonthlyBilling: 'This field is used to mark an account as part of the special case where the subscription is billed monthly on Stripe but operates under an annual commitment. When true, the account will follow yearly quota reset rules instead of monthly ones.',
        quotaRenewedOnDate: 'This field is used to identify one year from the last quota update. It handles a special case where the plan is monthly on Stripe but requires a yearly quota reset. This field is only applicable if Annual Plan Billed Monthly is true. It should always contain the date of the last yearly quota reset, and remain blank if the plan does not fall under this special case.',
        documentOverages: 'This should be set to zero for metered plans unless charges are applied manually, because for metered plans Stripe automatically generates the bill based on reported usage units.',
      },
      billing: {
        wrongAggregate: 'Usage type incorrect. If this subscription is PAYG, please create a new price with the correct aggregate usage.',
      },
    },
  },
};
